import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Internal dependencies
 */
import Button from './Button';
const Footer = ({ onClick }) => {
    return (_jsx("footer", { className: "corridor flex justify-center", children: _jsx(Button, { type: 'button', onClick: onClick, children: "Load more" }) }));
};
export default Footer;
